module.exports = __webpack_public_path__ + "static/img/12.70db2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/12.jpg
// module id = eZ3S
// module chunks = 1